import { pluralize, capitalize } from 'inflection'
import { useSelector } from 'react-redux'

const EventNoun = () => {
  const event = useSelector(state => state.event.event)

  if (event.auction_format === 10) {
    return capitalize(pluralize(event.event_type_noun || 'item'))
  } else {
    return 'Item'
  }
}

export default EventNoun



// WEBPACK FOOTER //
// ./src/components/EventNoun/index.jsx